import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { JamPadEvent } from '../DataModels';
import { UUID } from 'crypto';

import { ProfileEventView } from './ProfilePage.tsx';
import EventPreview from '../Events/EventPreview.tsx';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { EventMapContext } from '../App/App.tsx';

interface Props { profileID: UUID | undefined, view: ProfileEventView, currView: ProfileEventView,
    events: Map<UUID, JamPadEvent>, setEvents: any, seeFullEvent: any }
export default function ProfilePage({ profileID, view, currView, events, setEvents, seeFullEvent } : Props) {
    const eventLoadCount = 30;
    const [moreEvents, setMoreEvents] = useState(true);
    const [loading, setLoading] = useState(true);

    async function loadEvents() {
        setLoading(true);
        const { data: newEvents, error } = await supabase
            .rpc('load_profile_events', { 
                profile: profileID, event_type: view, 
                offset_count: events.size, limit_count: eventLoadCount
            })
            .select().overrideTypes<JamPadEvent[]>()
        if(error) { 
            console.error(error.message)
        } else {
            const newMap = new Map(events);
            newEvents.forEach((e) => { 
                e.date = new Date(e.date); 
                newMap.set(e.id, e);
            })
            setEvents(newMap);
            setMoreEvents(newEvents.length === eventLoadCount);
        }
        setLoading(false);
    };

    useEffect(()=> {
        if(view !== currView) { return }
        if(profileID && events.size === 0 && moreEvents) {
            loadEvents();
        } else {
            setLoading(false);
        }
    }, [profileID, currView]);

    return (<EventMapContext.Provider value={{ events, setEvents: (m) => {setEvents(m)} }}>
        <div style={{ 
            maxWidth: '100%', 
            display: currView === view ? 'flex' : 'none', 
            height: '78vh', overflow: 'hidden'
         }}>
            <Box sx={{  display: 'flex', 
                flexDirection: { xs: 'column', md: 'row' }, 
                flexWrap: {xs : 'nowrap', md: 'wrap' },
                gap: '10px', rowGap: '10px', justifyContent: 'center', alignItems: 'start',
                overflow: 'auto'
            }}>
                { events.size === 0 && !loading && 
                    <Typography variant='h6' fontWeight='bold' 
                        marginBottom='auto' paddingTop='20px'>[ No events ]</Typography> 
                }
                { Array.from(events.values()).map((e) => {
                    return <Box sx={{ 
                        flex: '1 0 45%', 
                        maxWidth: { xs: '100%', md: '49%' } 
                    }}>
                        <EventPreview key={e.id} event={e} 
                            seeFullEvent={() => {seeFullEvent(e)}}
                        />
                    </Box>
                })}
                { moreEvents && !loading &&
                    <Button style={{ flex: '1 0 100%' }} variant="contained" onClick={() => loadEvents()}>
                        Load More
                    </Button>
                }
                {/* bottom padding... */}
                <Box sx={{ 
                    flex: { xs: 'none', md: '1 0 100%' }, 
                    height: { xs: '50px', md: '20px' }
                }}></Box>
            </Box>
        </div>
        { loading && currView === view &&
            <CircularProgress style={{ 
                flex: '1',
                width: '40px', justifySelf: 'center'
            }}/>
        }
    </EventMapContext.Provider>);
}